import HeaderNavigation from "./components/header";

document.addEventListener("DOMContentLoaded", () => {
  new HeaderNavigation();
});
